import { Controller } from '@hotwired/stimulus';

/**
 * Listens to a textarea input and watch the amount of characters
 * If a limit is reached then it will stop the user from typing
 * and will show a warning message
 */
export default class WordCountController extends Controller {
    static DEFAULTS = {
        unit: 'caractère',
        maxLength: null,
    };

    connect() {
        if (this.element) {
            this.options = {
                ...WordCountController.DEFAULTS,
                maxLength: this.element.maxLength ?? null,
            };
            // if maxLength is set, we need to create a sibling div element below this.element
            this.countContainer = document.createElement('div');
            this.countContainer.classList.add(
                'text-xs',
                'absolute',
                'bottom-0',
                'right-0',
                'translate-y-full',
                'transform',
            );
            this.countContainer.innerHTML = this.element.value
                ? this.element.value.length
                : 0;
            this.element.parentNode.insertBefore(
                this.countContainer,
                this.element.nextSibling,
            );

            this.element.addEventListener(
                'input',
                this.updateCharLimit.bind(this),
            );
            this.updateCharLimit();
        }
    }

    disconnect() {
        if (this.element) {
            this.element.removeEventListener(
                'input',
                this.updateCharLimit.bind(this),
            );
        }
    }

    displayCurrentCount(currentLength) {
        let label = this.options.unit;
        if (currentLength !== 1) {
            label += 's';
        }

        let textToShow = `${currentLength}`;
        if (
            this.options.maxLength !== null &&
            this.options.maxLength !== -1 &&
            this.options.unit !== 'word'
        ) {
            textToShow += ` / ${this.options.maxLength}`;
        }
        textToShow += ` ${label}`;
        this.countContainer.innerText = textToShow;
    }

    updateCharLimit() {
        const currentLength = this.element.value.length;
        this.displayCurrentCount(currentLength);
    }
}
